"use strict";

var _regeneratorRuntime = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

require("isomorphic-fetch");

var relative_to_absolute_iri_1 = require("relative-to-absolute-iri");

var FetchDocumentLoader_1 = require("./FetchDocumentLoader");
/**
 * Parses JSON-LD contexts.
 */


var ContextParser =
/*#__PURE__*/
function () {
  function ContextParser(options) {
    _classCallCheck(this, ContextParser);

    options = options || {};
    this.documentLoader = options.documentLoader || new FetchDocumentLoader_1.FetchDocumentLoader();
    this.documentCache = {};
    this.validate = !options.skipValidation;
    this.expandContentTypeToBase = options.expandContentTypeToBase;
  }
  /**
   * Get the prefix from the given term.
   * @see https://json-ld.org/spec/latest/json-ld/#compact-iris
   * @param {string} term A term that is an URL or a prefixed URL.
   * @param {IJsonLdContextNormalized} context A context.
   * @return {string} The prefix or null.
   */


  _createClass(ContextParser, [{
    key: "parse",

    /**
     * Parse a JSON-LD context in any form.
     * @param {JsonLdContext} context A context, URL to a context, or an array of contexts/URLs.
     * @param {IParseOptions} options Optional parsing options.
     * @return {Promise<IJsonLdContextNormalized>} A promise resolving to the context.
     */
    value: function parse(context) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          baseIri = _ref.baseIri,
          parentContext = _ref.parentContext,
          external = _ref.external;

      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var contexts, newContext;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(context === null || context === undefined)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", baseIri ? {
                  '@base': baseIri
                } : {});

              case 4:
                if (!(typeof context === 'string')) {
                  _context.next = 17;
                  break;
                }

                if (ContextParser.isValidIri(context)) {
                  _context.next = 9;
                  break;
                }

                context = relative_to_absolute_iri_1.resolve(context, baseIri);

                if (ContextParser.isValidIri(context)) {
                  _context.next = 9;
                  break;
                }

                throw new Error("Invalid context IRI: ".concat(context));

              case 9:
                _context.t0 = this;
                _context.next = 12;
                return this.load(context);

              case 12:
                _context.t1 = _context.sent;
                _context.t2 = {
                  baseIri: baseIri,
                  parentContext: parentContext,
                  external: true
                };
                return _context.abrupt("return", _context.t0.parse.call(_context.t0, _context.t1, _context.t2));

              case 17:
                if (!Array.isArray(context)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 20;
                return Promise.all(context.map(function (subContext) {
                  if (typeof subContext === 'string') {
                    return _this.load(subContext);
                  } else {
                    return subContext;
                  }
                }));

              case 20:
                contexts = _context.sent;
                return _context.abrupt("return", contexts.reduce(function (accContextPromise, contextEntry) {
                  return accContextPromise.then(function (accContext) {
                    return _this.parse(contextEntry, {
                      baseIri: baseIri,
                      parentContext: accContext,
                      external: external
                    });
                  });
                }, Promise.resolve(parentContext)));

              case 24:
                if (!(typeof context === 'object')) {
                  _context.next = 40;
                  break;
                }

                if (!context['@context']) {
                  _context.next = 29;
                  break;
                }

                _context.next = 28;
                return this.parse(context['@context'], {
                  baseIri: baseIri,
                  parentContext: parentContext,
                  external: external
                });

              case 28:
                return _context.abrupt("return", _context.sent);

              case 29:
                // Make a deep clone of the given context, to avoid modifying it.
                context = JSON.parse(JSON.stringify(context)); // No better way in JS at the moment...
                // We have an actual context object.

                newContext = {}; // According to the JSON-LD spec, @base must be ignored from external contexts.

                if (external) {
                  delete context['@base'];
                } // Override the base IRI if provided.


                if (baseIri && !('@base' in newContext)) {
                  newContext['@base'] = baseIri;
                }

                newContext = Object.assign({}, newContext, parentContext, context);
                ContextParser.idifyReverseTerms(newContext);
                ContextParser.expandPrefixedTerms(newContext, this.expandContentTypeToBase);

                if (this.validate) {
                  ContextParser.validate(newContext);
                }

                return _context.abrupt("return", newContext);

              case 40:
                throw new Error("Tried parsing a context that is not a string, array or object, but got ".concat(context));

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "load",
    value: function load(url) {
      return __awaiter(this, void 0, void 0,
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2() {
        var cached;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                cached = this.documentCache[url];

                if (!cached) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return", Array.isArray(cached) ? cached.slice() : Object.assign({}, cached));

              case 3:
                _context2.next = 5;
                return this.documentLoader.load(url);

              case 5:
                return _context2.abrupt("return", this.documentCache[url] = _context2.sent['@context']);

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }], [{
    key: "getPrefix",
    value: function getPrefix(term, context) {
      var separatorPos = term.indexOf(':');

      if (separatorPos >= 0) {
        // Suffix can not begin with two slashes
        if (term.length > separatorPos + 1 && term.charAt(separatorPos + 1) === '/' && term.charAt(separatorPos + 2) === '/') {
          return null;
        }

        var prefix = term.substr(0, separatorPos); // Prefix can not be an underscore (this is a blank node)

        if (prefix === '_') {
          return null;
        } // Prefix must match a term in the active context


        if (context[prefix]) {
          return prefix;
        }
      }

      return null;
    }
    /**
     * From a given context entry value, get the string value, or the @id field.
     * @param contextValue A value for a term in a context.
     * @return {string} The id value, or null.
     */

  }, {
    key: "getContextValueId",
    value: function getContextValueId(contextValue) {
      if (contextValue === null || typeof contextValue === 'string') {
        return contextValue;
      }

      var id = contextValue['@id'];
      return id ? id : null;
    }
    /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will apply as much compaction iterations as possible to compact the IRI as much as possible.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalized} context A context.
     * @param {boolean} vocab If the term is a predicate or type and should be expanded based on @vocab,
     *                        otherwise it is considered a regular term that is expanded based on @base.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     */

  }, {
    key: "expandTerm",
    value: function expandTerm(term, context, vocab) {
      var termIn;

      do {
        termIn = term;
        term = ContextParser.expandTermSingle(term, context, vocab);
      } while (term && term !== termIn);

      return term;
    }
    /**
     * Expand the term or prefix of the given term if it has one,
     * otherwise return the term as-is.
     *
     * This will only perform a single compaction iteration over the context.
     *
     * Iff in vocab-mode, then other references to other terms in the context can be used,
     * such as to `myTerm`:
     * ```
     * {
     *   "myTerm": "http://example.org/myLongTerm"
     * }
     * ```
     *
     * @param {string} term A term that is an URL or a prefixed URL.
     * @param {IJsonLdContextNormalized} context A context.
     * @param {boolean} vocab If the term is a predicate or type and should be expanded based on @vocab,
     *                        otherwise it is considered a regular term that is expanded based on @base.
     * @return {string} The expanded term, the term as-is, or null if it was explicitly disabled in the context.
     */

  }, {
    key: "expandTermSingle",
    value: function expandTermSingle(term, context, vocab) {
      ContextParser.assertNormalized(context);
      var contextValue = context[term]; // Immediately return if the term was disabled in the context

      if (contextValue === null || contextValue && contextValue['@id'] === null) {
        return null;
      } // Check the @id


      if (contextValue && vocab) {
        var value = this.getContextValueId(contextValue);

        if (value && value !== term) {
          return value;
        }
      } // Check if the term is prefixed


      var prefix = ContextParser.getPrefix(term, context);

      if (prefix) {
        var _value = this.getContextValueId(context[prefix]);

        if (_value) {
          return _value + term.substr(prefix.length + 1);
        }
      } else if (vocab && context['@vocab'] && term.charAt(0) !== '@' && term.indexOf(':') < 0) {
        return context['@vocab'] + term;
      } else if (!vocab && context['@base'] && term.charAt(0) !== '@' && term.indexOf(':') < 0) {
        return relative_to_absolute_iri_1.resolve(term, context['@base']);
      }

      return term;
    }
    /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will apply as much compaction iterations as possible to compact the IRI as much as possible.
     *
     * @param {string} iri An IRI to compact.
     * @param {IJsonLdContextNormalized} context The context to compact with.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */

  }, {
    key: "compactIri",
    value: function compactIri(iri, context, vocab) {
      var iriIn;

      do {
        iriIn = iri;
        iri = ContextParser.compactIriSingle(iri, context, vocab);
      } while (iri && iri !== iriIn);

      return iri;
    }
    /**
     * Compact the given term using @base, @vocab, an aliased term, or a prefixed term.
     *
     * This will only perform a single compaction iteration over the context.
     *
     * @param {string} iri An IRI to compact.
     * @param {IJsonLdContextNormalized} context The context to compact with.
     * @param {boolean} vocab If the term is a predicate or type and should be compacted based on @vocab,
     *                        otherwise it is considered a regular term that is compacted based on @base.
     * @return {string} The compacted term or the IRI as-is.
     */

  }, {
    key: "compactIriSingle",
    value: function compactIriSingle(iri, context, vocab) {
      ContextParser.assertNormalized(context); // Try @vocab compacting

      if (vocab && context['@vocab'] && iri.startsWith(context['@vocab'])) {
        return iri.substr(context['@vocab'].length);
      } // Try @base compacting


      if (!vocab && context['@base'] && iri.startsWith(context['@base'])) {
        return iri.substr(context['@base'].length);
      } // Loop over all terms in the context


      for (var key in context) {
        var value = context[key];

        if (value && !key.startsWith('@')) {
          var contextIri = this.getContextValueId(value);

          if (iri.startsWith(contextIri)) {
            var suffix = iri.substr(contextIri.length);

            if (!suffix) {
              if (vocab) {
                // Compact aliased term
                return key;
              }
            } else {
              // Compact prefixed term
              return key + ':' + suffix;
            }
          }
        }
      }

      return iri;
    }
    /**
     * An an assert to check if the given context has been normalized.
     * An error will be thrown otherwise.
     * @param {JsonLdContext} context A context.
     */

  }, {
    key: "assertNormalized",
    value: function assertNormalized(context) {
      if (typeof context === 'string' || Array.isArray(context) || context['@context']) {
        throw new Error('The given context is not normalized. Make sure to call ContextParser.parse() first.');
      }
    }
    /**
     * Check if the given context value can be a prefix value.
     * @param value A context value.
     * @return {boolean} If it can be a prefix value.
     */

  }, {
    key: "isPrefixValue",
    value: function isPrefixValue(value) {
      return value && (typeof value === 'string' || value['@id'] || value['@type']);
    }
    /**
     * Check if the given IRI is valid.
     * @param {string} iri A potential IRI.
     * @return {boolean} If the given IRI is valid.
     */

  }, {
    key: "isValidIri",
    value: function isValidIri(iri) {
      return ContextParser.IRI_REGEX.test(iri);
    }
    /**
     * Add an @id term for all @reverse terms.
     * @param {IJsonLdContextNormalized} context A context.
     * @return {IJsonLdContextNormalized} The mutated input context.
     */

  }, {
    key: "idifyReverseTerms",
    value: function idifyReverseTerms(context) {
      for (var _i = 0, _Object$keys = Object.keys(context); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        var value = context[key];

        if (value && typeof value === 'object') {
          if (value['@reverse'] && !value['@id']) {
            if (typeof value['@reverse'] !== 'string') {
              throw new Error("Invalid @reverse value: '".concat(value['@reverse'], "'"));
            }

            value['@id'] = value['@reverse'];
            value['@reverse'] = true;
          }
        }
      }

      return context;
    }
    /**
     * Expand all prefixed terms in the given context.
     * @param {IJsonLdContextNormalized} context A context.
     * @param {boolean} expandContentTypeToBase If @type inside the context may be expanded
     *                                          via @base if @vocab is set to null.
     * @return {IJsonLdContextNormalized} The mutated input context.
     */

  }, {
    key: "expandPrefixedTerms",
    value: function expandPrefixedTerms(context, expandContentTypeToBase) {
      for (var _i2 = 0, _Object$keys2 = Object.keys(context); _i2 < _Object$keys2.length; _i2++) {
        var key = _Object$keys2[_i2];

        // Only expand allowed keys
        if (ContextParser.EXPAND_KEYS_BLACKLIST.indexOf(key) < 0) {
          // Error if we try to alias a keyword to something else.
          if (key[0] === '@' && ContextParser.ALIAS_KEYS_BLACKLIST.indexOf(key) >= 0) {
            throw new Error("Keywords can not be aliased to something else.\nTried mapping ".concat(key, " to ").concat(context[key]));
          } // Loop because prefixes might be nested


          while (ContextParser.isPrefixValue(context[key])) {
            var value = context[key];
            var changed = false;

            if (typeof value === 'string') {
              context[key] = ContextParser.expandTerm(value, context, true);
              changed = changed || value !== context[key];
            } else {
              var id = value['@id'];
              var type = value['@type'];

              if (id) {
                context[key]['@id'] = ContextParser.expandTerm(id, context, true);
                changed = changed || id !== context[key]['@id'];
              }

              if (type && type !== '@vocab') {
                // First check @vocab, then fallback to @base
                context[key]['@type'] = ContextParser.expandTerm(type, context, true);

                if (expandContentTypeToBase && type === context[key]['@type']) {
                  context[key]['@type'] = ContextParser.expandTerm(type, context, false);
                }

                changed = changed || type !== context[key]['@type'];
              }
            }

            if (!changed) {
              break;
            }
          }
        }
      }

      return context;
    }
    /**
     * Validate the entries of the given context.
     * @param {IJsonLdContextNormalized} context A context.
     */

  }, {
    key: "validate",
    value: function validate(context) {
      for (var _i3 = 0, _Object$keys3 = Object.keys(context); _i3 < _Object$keys3.length; _i3++) {
        var key = _Object$keys3[_i3];
        var value = context[key];
        var valueType = typeof value; // First check if the key is a keyword

        if (key[0] === '@') {
          switch (key.substr(1)) {
            case 'vocab':
              if (value !== null && valueType !== 'string') {
                throw new Error("Found an invalid @vocab IRI: ".concat(value));
              }

              break;

            case 'base':
              if (value !== null && valueType !== 'string') {
                throw new Error("Found an invalid @base IRI: ".concat(context[key]));
              }

              break;

            case 'language':
              if (value !== null && valueType !== 'string') {
                throw new Error("Found an invalid @language string: ".concat(value));
              }

              break;
          }
        } // Otherwise, consider the key a term


        if (value !== null) {
          switch (valueType) {
            case 'string':
              // Always valid
              break;

            case 'object':
              if (key.indexOf(':') < 0 && !('@id' in value) && (value['@type'] === '@id' ? !context['@base'] : !context['@vocab'])) {
                throw new Error("Missing @id in context entry: '".concat(key, "': '").concat(JSON.stringify(value), "'"));
              }

              for (var _i4 = 0, _Object$keys4 = Object.keys(value); _i4 < _Object$keys4.length; _i4++) {
                var objectKey = _Object$keys4[_i4];
                var objectValue = value[objectKey];

                if (!objectValue) {
                  continue;
                }

                switch (objectKey) {
                  case '@id':
                    if (objectValue[0] === '@' && objectValue !== '@type' && objectValue !== '@id') {
                      throw new Error("Illegal keyword alias in term value, found: '".concat(key, "': '").concat(JSON.stringify(value), "'"));
                    }

                    break;

                  case '@type':
                    if (objectValue !== '@id' && objectValue !== '@vocab' && (objectValue[0] === '_' || !ContextParser.isValidIri(objectValue))) {
                      throw new Error("A context @type must be an absolute IRI, found: '".concat(key, "': '").concat(objectValue, "'"));
                    }

                    break;

                  case '@reverse':
                    if (typeof objectValue === 'string' && value['@id'] && value['@id'] !== objectValue) {
                      throw new Error("Found non-matching @id and @reverse term values in '".concat(key, "':'").concat(objectValue, "' and '").concat(value['@id'], "'"));
                    }

                    break;

                  case '@container':
                    if (objectValue === '@list' && value['@reverse']) {
                      throw new Error("Term value can not be @container: @list and @reverse at the same time on '".concat(key, "'"));
                    }

                    if (ContextParser.CONTAINERS.indexOf(objectValue) < 0) {
                      throw new Error("Invalid term @container for '".concat(key, "' ('").concat(objectValue, "'), must be one of ").concat(ContextParser.CONTAINERS.join(', ')));
                    }

                    break;

                  case '@language':
                    if (objectValue !== null && typeof objectValue !== 'string') {
                      throw new Error("Found an invalid term @language string in: '".concat(key, "': '").concat(JSON.stringify(value), "'"));
                    }

                    break;
                }
              }

              break;

            default:
              throw new Error("Found an invalid term value: '".concat(key, "': '").concat(value, "'"));
          }
        }
      }
    }
  }]);

  return ContextParser;
}(); // Regex for valid IRIs


ContextParser.IRI_REGEX = /^([A-Za-z][A-Za-z0-9+-.]*|_):[^ "<>{}|\\\[\]`]*$/; // Keys in the contexts that will not be expanded based on the base IRI

ContextParser.EXPAND_KEYS_BLACKLIST = ['@base', '@vocab', '@language']; // Keys in the contexts that may not be aliased

ContextParser.ALIAS_KEYS_BLACKLIST = ['@container', '@graph', '@id', '@index', '@list', '@nest', '@none', '@prefix', '@reverse', '@set', '@type', '@value']; // All valid @container values

ContextParser.CONTAINERS = ['@list', '@set', '@index', '@language'];
exports.ContextParser = ContextParser;